// generated by genversion
export var version = '3.8.23';
//# sourceMappingURL=version.js.map